module.exports = __webpack_public_path__ + "img/quark.a74c34df.svg";